// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__2ec8c","spinner__wrapper":"styles_spinner__wrapper__33Vn-","noBackground":"styles_noBackground__3Iua7","lds-spinner":"styles_lds-spinner__aBA8C"};